import './index.less';

import { ArrowRightOutlined } from '@ant-design/icons';
import { ToastContainer } from '@bfe/moly';
import React, { lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useI18nContext } from '@/i18n/I18n';
import { WHITE_HOST } from '@/utils/constants/common';
import { SubAccountLoginRedirectErrorTrack } from '@/utils/trace-list/subAccount';

const LazyEntry = lazy(() => import('./lazyEntry'));

const SubLoginApp = () => {
  const [search] = useSearchParams();

  const fromOAuth = search.get('from') === 'oauth';
  const [$t, lang] = useI18nContext();

  const toLogin = () => {
    let url = `/login?${search}`;
    const mainLoginUrl = search.get('main_login_url');
    if (fromOAuth) {
      url = `/${lang}/oauth-login?${search}`;
    } else if (mainLoginUrl) {
      try {
        const mainLoginUrlNew = new URL(mainLoginUrl);
        if (
          WHITE_HOST.some((host) => mainLoginUrlNew?.host?.indexOf?.(host) > -1)
        ) {
          url = mainLoginUrl;
        } else {
          SubAccountLoginRedirectErrorTrack(search);
        }
      } catch (error) {
        /* empty */
      }
    }
    window.location.replace(url);
  };

  return (
    <>
      <div className="sub-account-login">
        <div className="sub-account-login-container">
          <div className="sub-account-login-container-top">
            <div className="sub-account-login-container-top-title" data-paint>
              {$t('loginSubAccount')}
            </div>
            <Suspense fallback={<div style={{ height: '120px' }}></div>}>
              <LazyEntry />
            </Suspense>
          </div>

          <div className="sub-account-login-container-bottom">
            <div className="sub-account-login-container-bottom-text">
              <span>{$t('switchTo')}</span>
              <span onClick={toLogin}>
                <span>{$t('mainAccountLogin')}</span>
                <ArrowRightOutlined />
              </span>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default SubLoginApp;
